import { render, staticRenderFns } from "./TheFilterTyreSort.vue?vue&type=template&id=fa08fa78&scoped=true&"
import script from "./TheFilterTyreSort.vue?vue&type=script&lang=js&"
export * from "./TheFilterTyreSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08fa78",
  null
  
)

export default component.exports